import { render } from "./LogoCell.vue?vue&type=template&id=2b1c42b9&scoped=true"
import script from "./LogoCell.vue?vue&type=script&lang=js"
export * from "./LogoCell.vue?vue&type=script&lang=js"

import "./LogoCell.vue?vue&type=style&index=0&id=2b1c42b9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1c42b9"]])

export default __exports__